/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import cx from 'classnames';

import ConfirmDialog from 'components/ConfirmDialog.jsx';
import QuickPromotion from 'entities/QuickPromotion';
import QuickPromotionActions from 'actions/QuickPromotionActions';
import { ImageTypes, PromotionTypes, ResponseTypes } from 'constants/QuickPromotionConstants';
import SisMergeExistingStudentModal from 'organizations/components/SisMergeExistingStudentModal.jsx';
import SisMergeExistingTeacherModal from 'organizations/components/SisMergeExistingTeacherModal.jsx';
import SisMergeExistingAccountsModal from 'organizations/components/SisMergeExistingAccountsModal.jsx';

import './styles/QuickPromotionModal.scss';

class QuickPromotionModal extends React.Component<{
  triggeredContext: string,
  promotion: QuickPromotion,
  onConfirm: (promotion: QuickPromotion, data: ?Object) => void,
  onCancel: (promotion: QuickPromotion) => void,
  onRequestHide: () => any,
}> {
  static childContextTypes = {
    eventScreenName: PropTypes.string,
    eventProperties: PropTypes.object,
  };

  getChildContext() {
    return {
      eventScreenName: 'QuickPromotionModal',
      eventProperties: { ui_context: this.props.triggeredContext },
    };
  }

  handleConfirm = (data: ?Object) => {
    this.props.onRequestHide();
    this.props.onConfirm(this.props.promotion, data);
  };
  handleCancel = () => {
    this.props.onRequestHide();
    this.props.onCancel(this.props.promotion);
  };
  renderCustom = () => {
    const { promotion } = this.props;

    const dismissPrompt = () => {
      QuickPromotionActions.recordDismissal(promotion, ResponseTypes.DISMISSED);
      this.props.onRequestHide();
    };

    switch (promotion.getPromotion()) {
      case 'sis_merge_existing_student':
        return (
          <SisMergeExistingStudentModal
            onConfirm={this.handleConfirm}
            promotion={promotion}
            onRequestHide={this.props.onRequestHide}
            onDialogDismiss={dismissPrompt}
          />
        );
      case 'sis_merge_existing_teacher':
        return (
          <SisMergeExistingTeacherModal
            onConfirm={this.handleConfirm}
            promotion={promotion}
            onRequestHide={this.props.onRequestHide}
            onDialogDismiss={dismissPrompt}
          />
        );
      case 'sis_merge_existing_accounts':
        return (
          <SisMergeExistingAccountsModal
            onConfirm={this.handleConfirm}
            onCancel={this.handleCancel}
            promotion={promotion}
            onRequestHide={() => {}}
          />
        );
      default:
        console.error('Unexpected custom quick promotion: ' + promotion.getPromotion());
        return null;
    }
  };
  render() {
    const { promotion } = this.props;

    if (promotion.getType() === PromotionTypes.CUSTOM) {
      return this.renderCustom();
    }

    let secondaryButton = false;
    let secondaryButtonText = '';
    const secondaryAction = promotion.getSecondaryAction();

    if (secondaryAction) {
      secondaryButton = true;
      secondaryButtonText = secondaryAction.getLabel();
    }

    return (
      <ConfirmDialog
        eventScreenName="QuickPromotionModal"
        className={cx('QuickPromotionModal', {
          'with-banner': promotion.getImageType() === ImageTypes.BANNER,
        })}
        size="xsmall"
        hideCloseButton={!promotion.isDismissable()}
        hideOnTransition={false}
        hideOnBlur={false}
        title={promotion.getHeader()}
        subtext={promotion.getBody()}
        image={promotion.getImageUrl()}
        actionButtonText={promotion.getPrimaryAction().getLabel()}
        hideCancel={!secondaryButton}
        cancelButtonText={secondaryButtonText}
        imageSize="large"
        onConfirm={this.handleConfirm}
        onCancel={this.handleCancel}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}

export default QuickPromotionModal;
